import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Geosuggest from 'react-geosuggest';
import styled from 'styled-components';
import './address-picker.css';

class AddressPicker extends Component {
  calculateTimeZone = callback => locationData => {
    return locationData ? callback(locationData) : null;
  };

  render() {
    const { initialValue, onSelect, className, placeholder } = this.props;

    return (
      <Container className={className}>
        <Geosuggest
          autoActivateFirstSuggest={true}
          autoFocus={true}
          initialValue={initialValue}
          onKeyPress={() => this.onSelect}
          onSuggestSelect={this.calculateTimeZone(onSelect)}
          placeholder={placeholder}
          types={['address']}
        />
      </Container>
    );
  }
}

AddressPicker.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
};

AddressPicker.defaultProps = {
  onChange: () => {},
  onSelect: () => {},
};

const Container = styled.div`
  font-size: 16px;
`;

export default AddressPicker;
